import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PersonIcon from '@mui/icons-material/Person';
import { Grid, IconButton } from '@mui/material';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import Close from '@mui/icons-material/Close';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveIcon from '@mui/icons-material/Remove';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PortraitIcon from '@mui/icons-material/Portrait';

const NotificationCard = ({
  notification,
  notificationExists,
  message,
  removeNotification,
}) => {
  return (
    <>
      {notificationExists ? (
        <Card
          elevation={3}
          sx={{ display: 'flex', position: 'relative', width: '100%' }}
        >
          <IconButton
            sx={{ position: 'absolute', top: '0', right: '0', padding: '6px' }}
            onClick={(event) => removeNotification(event, notification.id)}
          >
            <RemoveCircleOutlineIcon
              color="error"
              sx={{ width: '20px', height: '20px' }}
            />
          </IconButton>
          <Grid sx={{ width: '100%' }} container wrap="nowrap">
            <Grid
              item
              sx={{
                width: '15%',
                maxWidth: '15%',
                alignSelf: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <PersonIcon
                color="primary"
                sx={{ width: '30px', height: '30px' }}
              />
            </Grid>
            <Grid item sx={{ marginLeft: '0', width: '85%', maxWidth: '85%' }}>
              <CardContent
                sx={{
                  padding: '20px 20px 20px 0 !important',
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'pre-wrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {message}
                </Typography>
              </CardContent>
            </Grid>
          </Grid>
        </Card>
      ) : (
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            width: '100%',
            backgroundColor: 'transparent',
            boxShadow: 'none !important',
            ':hover': {
              boxShadow: 'none !important',
              backgroundColor: 'transparent',
            },
            border: 'none',
            cursor: 'default',
          }}
        >
          <Typography variant="body2">No new messages</Typography>
        </Card>
      )}
    </>
  );
};

export default NotificationCard;
